"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _mapActions = require("../actions/mapActions");

var _sc = require("../actions/sc4");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MapPanel = function MapPanel(_ref) {
  var initialMapLocation = _ref.initialMapLocation,
      userType = _ref.userType,
      userMuniCounty = _ref.userMuniCounty;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _mapActions.initializeOutageMap)(userType, userMuniCounty, initialMapLocation));
  }, [dispatch, initialMapLocation, userType, userMuniCounty]);
  (0, _react.useEffect)(function () {
    var mapUpdateInterval = setInterval(function () {
      dispatch((0, _sc.refreshData)(userType, userMuniCounty));
    }, 60 * 1000);
    return function () {
      clearInterval(mapUpdateInterval);
    };
  }, [dispatch, userType, userMuniCounty]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: 'map',
    style: {
      height: '100%'
    }
  });
};

MapPanel.propTypes = {
  initialMapLocation: _propTypes.default.string,
  userMuniCounty: _propTypes.default.string.isRequired,
  userType: _propTypes.default.any.isRequired
};
var _default = MapPanel;
exports.default = _default;